import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Competition} from '../../model/competition/Competition';
import {NotificationHandler} from '../../helper/notification.handler';
import {CompetitionService} from '../../service/competition.service';
import {MatSelectChange} from '@angular/material/select';
import {Role} from '../../model/auth/Role';
import {LocalStorageService} from 'ngx-webstorage';
import {LocalStorageKeys} from '../../helper/local-storage.keys';

@Component({
  selector: 'competition-select',
  templateUrl: './competition-select.component.html',
  styleUrls: ['./competition-select.component.scss']
})
export class CompetitionSelectComponent {

  readonly roles = [Role.Admin, Role.Host];

  @Input() disabled = false;

  @Input() autoSelect = false;
  @Input() persistSelection = false;

  @Output() selected = new EventEmitter<Competition>();

  competitions!: Competition[] | null;
  selectedValue?: Competition;

  constructor(private competitionService: CompetitionService,
              private localStorageService: LocalStorageService) {
  }

  initContent() {
    this.loadCompetitions();
  }

  compareWith(c1: Competition, c2: Competition) {
    return c1 && c2 && c1.id === c2.id;
  }

  private loadCompetitions() {
    this.competitions = null;

    this.competitionService.getCompetitions().subscribe(competitions => {
      this.competitions = competitions;

      const persisted = this.localStorageService.retrieve(LocalStorageKeys.SELECTED_COMPETITION_ID) as string;
      if (persisted) {
        const competition = this.competitions.find(c => c.id === persisted);
        if (competition) {
          this.selectedValue = competition;
        } else {
          this.localStorageService.clear(LocalStorageKeys.SELECTED_COMPETITION_ID);
        }
      }

      if (!this.selectedValue && this.autoSelect) {
        if (this.competitions && this.competitions.length > 0) {
          this.selectedValue = this.competitions[0];

          this.persist(this.selectedValue.id);
        } else {
          this.disabled = true;
          this.persist('');
        }
      }
    }, error => NotificationHandler.handleError($localize`:Notifications|Competitions fetch has failed message@@notifications-competitions-fetch-failed-error:Competitions fetch has failed`, error));
  }

  competitionSelected(change: MatSelectChange) {
    const competition = change.value as Competition;

    this.persist(competition.id);

    this.selected.emit(competition);
  }

  private persist(competitionId: string): void {
    if (this.persistSelection) {
      this.localStorageService.store(LocalStorageKeys.SELECTED_COMPETITION_ID, competitionId);
    }
  }
}
